import { observer } from 'mobx-react-lite';
import { FC, useEffect } from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import { useMask } from '@react-input/mask';
import { useService } from '~/services/service.base';
import { WrapperService } from '~/services/service.wrapper';
import { DialogService } from '~/services/service.dialog';
import { VerificationCodeDialog } from '~/views/organisms/verification.code.dialog';

export const PersonalInfo: FC = observer(() => {
    const dialogService = useService(DialogService);
    const { verificationCodeDialogSrv } = dialogService;

    const wrapperService = useService(WrapperService);
    const { authService, accountService } = wrapperService;
    const dateOfBirthRef = useMask({ mask: '__/__/____', replacement: { _: /\d/ } });

    useEffect(() => {
        window.addEventListener('keyup', e =>
            accountService.onLinkAccountKeyUp(e, verificationCodeDialogSrv, authService.currentUser?.token),
        );
    }, []);

    const afterVerifyCode = async (verificationCode: string) => {
        const verifyResult = await accountService.linkUnityAccount(authService.currentUser, verificationCode);
        if (verifyResult) {
            verificationCodeDialogSrv.handleClose();
            authService.getUnityUser();
        }
    };

    return (
        <div className="account-content">
            <div className="account-content-inner">
                <h3>Personal info</h3>
                <h5>Account info</h5>
                <div className="personal-info-form-wrap">
                    <div className="pi-form-row">
                        <div className="pi-form-item">
                            <label htmlFor="first-name" className="form-label">
                                First Name
                            </label>
                            <input
                                id="first-name"
                                className="form-control"
                                name="first-name"
                                type="text"
                                disabled={true}
                                value={authService.currentUser?.firstName ? authService.currentUser?.firstName : ''}
                            />
                        </div>
                        <div className="pi-form-item">
                            <label htmlFor="last-name" className="form-label">
                                Second Name
                            </label>
                            <input
                                id="last-name"
                                className="form-control"
                                name="last-name"
                                type="text"
                                disabled={true}
                                value={authService.currentUser?.lastName ? authService.currentUser?.lastName : ''}
                            />
                        </div>
                    </div>
                    <div className="pi-form-row">
                        <div className="pi-form-item">
                            <label htmlFor="phone" className="form-label">
                                Phone
                            </label>
                            <input
                                id="phone"
                                className="form-control"
                                name="phone"
                                type="text"
                                disabled={true}
                                value={authService.currentUser?.phoneNumber ? authService.currentUser?.phoneNumber : ''}
                            />
                        </div>
                        <div className="pi-form-item">
                            <label htmlFor="email" className="form-label">
                                Email
                            </label>
                            <input
                                id="email"
                                className="form-control"
                                name="email"
                                type="text"
                                disabled={true}
                                value={authService.currentUser?.email ? authService.currentUser?.email : ''}
                            />
                        </div>
                    </div>
                </div>
                <div className="link-account-form-wrap">
                    {accountService.showLoading ? <LinearProgress /> : null}
                    <div className="la-form-row">
                        <div
                            className={
                                'la-form-item' + (accountService.isLinkUnityEmailInvalid ? ' link-unity-error' : '')
                            }
                        >
                            <label htmlFor="unity-account" className="form-label">
                                email address or unity account number
                            </label>
                            {!authService.showUnityBanner && (
                                <input
                                    className="form-control"
                                    disabled={true}
                                    name="unity-account"
                                    type="text"
                                    defaultValue={authService.currentUser?.unityAccountNumber}
                                />
                            )}
                            {authService.showUnityBanner && (
                                <input
                                    className="form-control"
                                    name="unity-account"
                                    type="text"
                                    onBlur={accountService.handleUnityEmailBlur}
                                />
                            )}
                            {accountService.lastError.description && (
                                <div className="email-error-msg">{accountService.lastError.description}</div>
                            )}
                        </div>
                    </div>
                    <div className="la-form-row">
                        <div
                            className={
                                'la-form-item' + (accountService.isDateOfBirthInvalid ? ' link-unity-error' : '')
                            }
                        >
                            <label htmlFor="date-birth" className="form-label">
                                Date of birth
                            </label>
                            <input
                                id="date-birth"
                                className="form-control"
                                name="date-birth"
                                type="text"
                                placeholder="MM/DD/YYYY"
                                autoComplete="off"
                                ref={dateOfBirthRef}
                                onChange={accountService.handleDateOfBirthChange}
                                onFocus={accountService.handleDateOfBirthLinkFocus}
                            />
                        </div>
                        <div className="la-form-item">
                            <div className="link-unity-btn-wrap">
                                <button
                                    type="button"
                                    id="link-unity-btn"
                                    className="btn"
                                    onClick={() =>
                                        accountService.openVerificationCodeDialog(
                                            verificationCodeDialogSrv,
                                            authService.currentUser?.token,
                                        )
                                    }
                                    disabled={accountService.isLinkAccountBtnDisabled}
                                >
                                    Link Account
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {verificationCodeDialogSrv.open ? (
                <VerificationCodeDialog
                    onSendVerificationCode={() => accountService.sendVerificationCode(authService.currentUser?.token)}
                    onEnterVerificationCode={verificationCode => afterVerifyCode(verificationCode)}
                />
            ) : null}
        </div>
    );
});
